export default function NotFound() {
  return (
    <h3 className="text-center mt-3">404 page not Found</h3>
  )
}
